import React, { useState, useEffect } from 'react'
import { useTracking } from "react-tracking";
import {
  Button, Container, Stack, TextField, Typography, DialogActions, Alert, Pagination, Grid, InputAdornment, Modal, Fade, Box, List,
  ListItem, ListItemIcon, DialogTitle, IconButton,
  Select,
  MenuItem,
  ListItemText,
  FormControl,
  InputLabel,
  Autocomplete
} from '@mui/material'
import { makeStyles } from '@mui/styles'
import toast from 'react-hot-toast'
import AddIcon from '@mui/icons-material/Add'
import SvgIcon from "@mui/material/SvgIcon";
//import SearchIcon from "@mui/icons-material/Search";
import InputSearchIcon from "../assets/icons/icon-feather-search.png"
import { ReactComponent as FolderIcon } from "../assets/icons/Folder_icon.svg"

import { Link as RouterLink } from 'react-router-dom'
// components
import Page from '../components/Page'
import Loader from './Loader'
import Popup from '../components/Popup'
import { ReportSort, ReportList } from '../components/_report/cards'

import { getReportsList, deleteReport, getReportsWithFolders, removeReportFromFolder, changeReportOwner } from '../config/services/reports'
import { addFolder, updateFolder, deleteFolder, addReportToFolder, getAllFolders } from '../config/services/reportFolder'

import Controls from '../components/controls/Controls'
import { getUsersList, markReportFavourite } from '../config/services/users'
import { useNavigate, useSearchParams } from "react-router-dom";
import ErrorOutlineSharpIcon from '@mui/icons-material/ErrorOutlineSharp';
import { LoadingButton } from '@mui/lab';

const useStyles = makeStyles((theme) => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  modalPaper: {
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #fff',
    boxShadow: '0px 0px 4px #0000001A',
    minWidth: '300px',
    borderRadius: '4px',
    textAlign: 'center',
  },
  selectFolderModalPaper: {
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #fff',
    boxShadow: '0px 0px 4px #0000001A',
    padding: '1rem',
    minWidth: '400px',
    borderRadius: '4px',
    textAlign: 'center',
    [theme.breakpoints.down('sm')]: {
      width: '90%',
      minWidth: '90%',
    },
  },
  modalTitle: {
    fontSize: '18px',
  },
  outlineButton: {
    color: '#85888A',
    fontSize: '14px',
    border: '1px solid #DEDEDE',
    borderRadius: '4px',
    fontWeight: 'normal',
    marginRight: '10px',
    padding: '0.5rem 1.5rem'
  },
  containedButton: {
    color: '#fff',
    fontSize: '14px',
    border: '1px solid #F45E29',
    borderRadius: '4px',
    fontWeight: 'normal',
    padding: '0.5rem 1.5rem'
  },
  headerFormItem: {
    paddingTop: '1rem !important',
    [theme.breakpoints.between('xs', 'sm')]: {
      paddingTop: '1rem !important',
    },
  },
  selectFolderList: {
    width: '100%',
    backgroundColor: '#F1F1F1',
    maxHeight: '300px',
    minHeight: '300px',
    overflowY: 'auto',
    marginBottom: '1rem',
  }
}));

export default function ReportApp(props) {
  const [searchParams, setSearchParams] = useSearchParams();
  const currentPage = searchParams.get('pageNo');
  const { folderId } = props
  const classes = useStyles();
  const [reportList, setReportsList] = useState([])
  const [reportListTotalCount, setReportsListCount] = useState(0)
  const [search, setSearchValue] = useState('')
  const [sortObj, setSortObj] = useState({ sortKey: 'updatedAt', sortOrder: '-1' })
  const [loader, setLoading] = useState(false)
  const [pageNo, setPagination] = useState(currentPage ? parseInt(currentPage) : 1)
  const [itemsPerPage, setItemsPerPage] = useState(8)
  const [reportsPerPage, setReportsPerPage] = useState(8)
  const [foldersPerPage, setFoldersPerPage] = useState(9)
  const [deleteObj, setDeleteObj] = useState({ reportId: '', reportName: '' })
  const [deletePopup, setDeletePopup] = useState(false)
  const [addFolderPopup, setAddFolderPopup] = useState(false)
  const [folderName, setFolderName] = useState('')
  const [folderDescription, setFolderDescription] = useState('')
  const [tempFolderId, setTempFolderId] = useState(null)
  const [error, setError] = useState({})
  const [moveReportPopup, setMoveReportPopup] = useState(false)  
  const [moveReportObj, setMoveReportObj] = useState({})
  const [changeOwnerPopup,setChangeOwnerPopup] = useState(false)
  const [changeOwnerReportObj,setChangeOwnerReportObj] = useState(null)
  const [changeOwnerObj,setOwnerObj] = useState(null)
  const [changeOwnerLoading,setChangeOwnerLoading] =  useState(false)
  const [userList,setUserList] = useState([])
  const [foldersList, setFoldersList] = useState([])
  const [restrictOption, setRestrictOption] = useState(false)
  const [removeReportFromFolderObj, setRemoveReportFromFolderObj] = useState({})
  const [moveOutReportPopup, setMoveOutReportPopup] = useState(false)
  const { trackEvent } = useTracking()
  const navigate = useNavigate();

  const fetchFoldersList = async () => {
    const { folderId } = moveReportObj
    let params = {currentFolderId: folderId}
    let response = await getAllFolders(params)
    if (response?.result) {
      setFoldersList(response.result)
    }
    else if (response?.data?.statusCode === 0) {
      console.error(response?.data?.error?.errorMessage)
    }
  }

  useEffect(() => fetchFoldersList(), [moveReportPopup])

  const fetchReportsList = async () => {
    let params = { pageNo: pageNo - 1, count: itemsPerPage, search, ...sortObj }
    let response

    if (props?.favouriteFilter === true) {
      params.favouriteFilter = true
    }

    setLoading(true)

    if (folderId || props?.favouriteFilter === true) {
      params.folderId = folderId
      response = await getReportsList(params)

      if (!response?.result?.length && params.pageNo > 0) {
        params.pageNo = params.pageNo - 1
        response = await getReportsList(params)
      }
    }
    else {
      params.reportsCount = reportsPerPage
      params.foldersCount = foldersPerPage
      response = await getReportsWithFolders(params)
    }

    if (response?.result) {
      setReportsList(response.result)
      setReportsListCount(response.totalCount)
      setLoading(false)
    }
    else if (response?.data?.statusCode === 0) {
      toast.success(response?.data?.error?.errorMessage)
      setLoading(false)
    }
  }

  const handleFavrtReport = (params) => {
    let reqParams = { reportId: params._id, isFavourite: params.isFavourite }
    setLoading(true)

    markReportFavourite(reqParams).then((res) => {
      fetchReportsList()
      toast.success(res.message)
    })
  }

  const handleFolderName = (e) => {
    let { value } = e.target
    setFolderName(value)
    setError({ ...error, folderError: '' })
  }
  const handleFoldeDescription = (e) => {
    let { value } = e.target
    setFolderDescription(value)
    setError({ ...error, folderError: '' })
  }

  const handleAddFolderPopup = (type, details) => {
    trackEvent({ Component: 'handleAddFolderPopup', event: "AddFolderButtonClick", type, funcName: 'handleAddFolderPopup' })

    switch (type) {
      case 'Add':
        setAddFolderPopup(true)
        break

      case 'Cancel':
        setAddFolderPopup(false)
        setFolderName('')
        setFolderDescription('')
        setTempFolderId(null)
        setError({ ...error, folderError: '' })
        break

      case 'Edit':
        setFolderName(details?.folderName)
        setFolderDescription(details?.folderDescription)
        setTempFolderId(details?._id)
        setAddFolderPopup(true)
        break
    }
  }

  const submitAddFolder = () => {
    if (!folderName) {
      setError({ ...error, folderError: 'Folder Name Is Required' })
      return
    }
    else {
      let params = { folderName, folderDescription }
      handleAddFolder(params)
    }
  }


  const handleAddFolder = async (params) => {
    let response
    setLoading(true)

    if (tempFolderId) {
      params.folderId = tempFolderId
      response = await updateFolder(params)
    }
    else {
      response = await addFolder(params)
    }

    if (response.result) {
      fetchReportsList()
      handleAddFolderPopup('Cancel')
      toast.success(response.message)
    }
    else if (response?.data?.statusCode === 0) {
      setError({ ...error, folderError: response?.data?.error?.errorMessage })
      setLoading(false)
    }
  }

  const onChangeOwner = () => {
    setChangeOwnerLoading(true)
    let reportObj = {
      reportId: changeOwnerReportObj.reportId,
      newOwner: changeOwnerObj.s_uuid
    }
    changeReportOwner(reportObj)
      .then((res) => {
        if(res.result){
          setChangeOwnerLoading(false)
          setChangeOwnerPopup(false)
          setChangeOwnerReportObj(null)
          setOwnerObj(null)
          fetchReportsList()
          toast.dismiss()
          toast.success('Owner changed successfully')
        }else{
          setChangeOwnerLoading(false)
          toast.dismiss()
          toast.error('Something went wrong while changing the report owner')
        }        
      })
      .catch(
        err => {
          console.log(err)
          setChangeOwnerLoading(false)
          toast.dismiss()
          toast.error('Something went wrong while changing the report owner')
        }
      )
    //console.log(reportObj)
  }

  const handleChangeOwnerPopup = (type, details) => {
    let trackEventObj = {
      Component: 'ReportApp',
      event: "ChangeOwnerReportButtonClick",
      funcName: 'handleChangeOwnerPopup',
      type,
      params: {}
    }
    if (details?._id) {
      trackEventObj.params = { reportId: details?._id }
    }
    trackEvent(trackEventObj)

    switch (type) {
      case 'Open':
        setChangeOwnerPopup(true)
        getUsersList({sortKey:'firstName',sortOrder:'asc'})
          .then(
            res => {
              console.log(res) 
              let users =   res?.result ?? []
              let currentOwner = users.find(obj => obj.s_uuid == details?.createdBy)
              setUserList(users)           
              setChangeOwnerReportObj({ reportId: details._id,currentOwner:currentOwner,reportName:details?.reportName , folderId: details?.folderId})
            }
          )        
        break
      case 'Cancel':
        setChangeOwnerPopup(false)
        setChangeOwnerReportObj(null)
        break
    }
  }


  const handleMoveReportPopup = (type, details) => {
    let trackEventObj = {
      Component: 'ReportApp',
      event: "MoveReportButtonClick",
      funcName: 'handleMoveReportPopup',
      type,
      params: {}
    }
    if (details?._id) {
      trackEventObj.params = { reportId: details?._id }
    }
    trackEvent(trackEventObj)

    switch (type) {
      case 'Open':
        setMoveReportPopup(true)
        setMoveReportObj({ reportId: details._id, folderId: details?.folderId})
        break
      case 'Cancel':
        setMoveReportPopup(false)
        setMoveReportObj({})
        break
    }
  }

  const handleMoveReport = (folder) => {
    setMoveReportObj({ ...moveReportObj, folderId: folder._id })
  }

  const submitMoveReport = async () => {
    let reqParams = { ...moveReportObj }
    if (folderId) {
      reqParams.oldFolderId = folderId
    }
    let response = await addReportToFolder(reqParams)

    if (response.result) {
      fetchReportsList()
      handleMoveReportPopup('Cancel')
      toast.success(response.message)
    }
    else if (response?.data?.statusCode === 0) {
      setError({ ...error, moveReportError: response?.data?.error?.errorMessage })
      setLoading(false)
    }
  }

  const handleSearch = (e) => {
    let { value } = e.target
    setPagination(1)
    setSearchValue(value)
    trackEvent({ Component: 'ReportApp', event: "SearchReports", funcName: 'handleSearch', value })
  }

  const handleSort = (params) => {
    let { sortOrder, sortKey } = params
    trackEvent({ Component: 'ReportApp', event: "SortReportsButtonClick", funcName: 'handleSort', params })
    setSortObj({ sortKey, sortOrder })
  }

  const handlePagination = (e, pageNumber) => {
    // console.log(pageNumber,'...........pageNumber')
    setPagination(pageNumber);
  }


  const handleRemoveReportFrmFolder = (type, reportDetails) => {
    switch (type) {
      case 'Open':
        setMoveOutReportPopup(true)
        setRemoveReportFromFolderObj({ folderId: reportDetails.folderId, reportId: reportDetails._id })
        break
      case 'Cancel':
        setMoveOutReportPopup(false)
        setRemoveReportFromFolderObj({})
        break
    }
  }


  const submitMoveOutReport = async () => {
    let { reportId, folderId } = removeReportFromFolderObj
    setLoading(true)

    return removeReportFromFolder({ reportId, folderId })
      .then(response => {
        if (response.result) {
          fetchReportsList()
          handleRemoveReportFrmFolder('Cancel')
          toast.success(response.message)
        }
        else if (response?.data?.statusCode === 0) {
          setError({ ...error, deleteError: response?.data?.error?.errorMessage })
          setLoading(false)
        }
        else {
          setLoading(false)
          console.error(response)
        }
      })
  }

  const handleDeleteReport = (params) => {
    if (params.isFolder) {
      setDeleteObj({ folderId: params._id, folderName: params.folderName, isFolder: params.isFolder })
    }
    else {
      setDeleteObj({ reportId: params._id, reportName: params.reportName, isFolder: false })
    }
    setDeletePopup(true)
    trackEvent({ Component: 'ReportApp', event: "DeleteReportButtonClick", funcName: 'handleDeleteReport', params: { folderId: params._id, folderName: params.folderName, isFolder: params.isFolder } })
  }

  const submitDeleteReport = async () => {
    let { reportId, folderId, isFolder } = deleteObj
    let response
    setLoading(true)

    if (isFolder) {
      response = await deleteFolder({ folderId })
    }
    else {
      response = await deleteReport({ reportId })
    }

    if (response.result) {
      trackEvent({ Component: 'ReportApp', event: "DeleteReport", funcName: 'submitDeleteReport', response, success: true })

      fetchReportsList()
      handleCancelDelete()
      toast.success(response.message)
    }
    else if (response?.data?.statusCode === 0) {
      trackEvent({ Component: 'ReportApp', event: "DeleteReport", funcName: 'submitDeleteReport', response, success: false })

      setError({ ...error, deleteError: response?.data?.error?.errorMessage })
      setLoading(false)
    }
  }

  const handleCancelDelete = () => {
    setDeletePopup(false)
    setDeleteObj({})
  }

  /* useEffect(() => {
    if (currentPage !== pageNo) {
      setSearchParams({ ...searchParams, pageNo: pageNo })
    }
    fetchReportsList()
  }, [sortObj, pageNo, itemsPerPage]) */

  useEffect(() => {
    let timeout;
    if (search !== '') {
      timeout = setTimeout(() => fetchReportsList(), 800);
    } else {
      setSearchParams({ ...searchParams, pageNo: 1 })
      setPagination(pageNo);
      fetchReportsList();
    }
    return () => Boolean(timeout) && clearTimeout(timeout);
  }, [search,sortObj, pageNo, itemsPerPage])

  const handleNewReportAccess = (redirect = null) => {
    if (window.innerWidth > 900 && redirect) {
      let redirectRoute = redirect

      if (folderId && props.folderName) {
        redirectRoute = `${redirect}?folderId=${folderId}&folderName=${props.folderName}`
      }
      else {
        if (pageNo) {
          redirectRoute = `${redirectRoute}?pageNo=${pageNo}`
        }
      }

      navigate(redirectRoute);
    }
    else {
      setRestrictOption(true);
    }
  }

  const handleReportAccess = (redirect = null) => {
    if (window.innerWidth > 900 && redirect) {
      navigate(redirect);
    }
    else {
      setRestrictOption(true);
    }
  }

  const handleViewReport = (redirect = null) => {
    trackEvent({ Component: 'ReportApp', event: "ViewReport", funcName: 'handleViewReport', params: { redirect } })
    navigate(redirect);
  }

  return (
    <Page title="Extramarks | Reports ">
      <Grid className="reports-list">
        <Grid container alignItems="left" justifyContent="flex-start" mb={2} spacing={2.5} >
          <Grid item xs={12} sm={12} md={6} lg={6} className={classes.headerFormItem} >
            <TextField fullWidth className={`report_form_ui_input pl-0 ` + classes.formInput} type="search"
              placeholder="Search By Report Name"
              onChange={handleSearch}
              InputLabelProps={{ style: { ...({ top: `${-7}px` }) } }}

              inputProps={{
                'track-this': 'Search Box',
                'tracked-type': 'search',
              }}

              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Box component="img" src={InputSearchIcon} className="input_search_icon" />
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={6} className={classes.headerFormItem} >
            <Grid container justifyContent="flex-end" spacing={2.5}>
              <Grid item xs={12} sm={(props?.favouriteFilter === true) ? 12 : folderId ? 6: 4} >
                <ReportSort className="report_form_ui_input_select" handleSort={handleSort} />
              </Grid>

              {(props?.favouriteFilter === true || folderId) ? null : <Grid className="report-grid-item-end" item xs={12} sm={4} justifyContent="flex-end"  >
                <Controls.Button track-this="Add Folder" tracked-type="button" name="Add Folder" className="report_form_ui_btn primary width-100 reports-head-btn" text="Add Folder" variant="contained" startIcon={<AddIcon className="btn_icon_before" />} onClick={() => handleAddFolderPopup('Add')} />
              </Grid>}

              {props?.favouriteFilter === true ? null :
                <Grid className="report-grid-item-end" item xs={12} sm={folderId ? 6 : 4} justifyContent="flex-end"  >
                  <Controls.Button track-this="New Report" tracked-type="button" name="New Report" className="report_form_ui_btn primary width-100 reports-head-btn" text="New Report" variant="contained" startIcon={<AddIcon className="btn_icon_before" />} onClick={() => handleNewReportAccess("/reportGraph/new")} />
                </Grid>
              }
            </Grid>
          </Grid>
        </Grid>

        {loader && <Loader />}
        {reportList?.length ? (
          <ReportList
            list={reportList}
            handleDeleteReport={handleDeleteReport}
            handleFavrtReport={handleFavrtReport}
            handleAddFolderPopup={handleAddFolderPopup}
            handleMoveReportPopup={handleMoveReportPopup}
            handleEditReport={handleReportAccess}
            handleRemoveReportFrmFolder={handleRemoveReportFrmFolder}
            handleViewReport={handleViewReport}
            handleChangeOwnerPopup={handleChangeOwnerPopup}
            pageNo={pageNo}
          />
        ) : (
          <Alert severity="error">No Content Available!</Alert>
        )}
      </Grid>

      {reportList?.length ? <div className="center cm_pagination">
        <Pagination
          count={Math.ceil(Number((reportListTotalCount / 8)))}
          variant="outlined"
          color="primary"
          onChange={handlePagination}
          page={pageNo}
        />
      </div> : null}

      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className="modal-root"
        open={deletePopup}
        closeAfterTransition
      >
        <Fade in={deletePopup}>
          <Box className="modal-paper modal-box modal-sm" id="transition-modal-title">
            <Box className="modal-content-simple">
              <Typography variant="subtitle1" className="modal-heading-title-simple">{`Are you sure to delete this ${deleteObj.isFolder ? 'Folder' : 'Report'} "${deleteObj.isFolder ? deleteObj.folderName : deleteObj.reportName}" ?`}</Typography>
              {deleteObj?.isFolder ? <Typography variant="body2" className='text-small text-center'>(Deleting a folder will also delete all the reports inside that folder.)</Typography> : null}
              <Box className="modal-footer-simple">
                <Button onClick={handleCancelDelete} color="primary" className="report_form_ui_btn cancel mr-2" variant="outlined" > Cancel </Button>
                <Button onClick={submitDeleteReport} color="error" autoFocus className="report_form_ui_btn submit" variant="contained"> Delete </Button>
              </Box>
            </Box>
          </Box>
        </Fade>
      </Modal>

      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className="modal-root"
        open={moveOutReportPopup}
        closeAfterTransition
      >
        <Fade in={moveOutReportPopup}>
          <Box className="modal-paper modal-box modal-sm" id="transition-modal-title">
            <Box className="modal-content-simple">
              <Typography variant="subtitle1" className="modal-heading-title-simple">{`Are you sure to move out this Report ?`}</Typography>
              <Box className="modal-footer-simple">
                <Button onClick={e => handleRemoveReportFrmFolder('Cancel')} color="primary" className="report_form_ui_btn cancel mr-2" variant="outlined" > Cancel </Button>
                <Button onClick={submitMoveOutReport} color="error" autoFocus className="report_form_ui_btn submit" variant="contained"> Move Out </Button>
              </Box>
            </Box>
          </Box>
        </Fade>
      </Modal>


      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={addFolderPopup}
        closeAfterTransition
      >
        <Fade in={addFolderPopup}>
          <Box className={classes.modalPaper + " modal-box modal-md"} id="transition-modal-title">
            <Box className="modal-header p-1" >
              <Typography variant="subtitle1" className={classes.modalTitle + " modal-header-title"} >{`Create New Folder`}</Typography>
            </Box>
            <Box className="modal-content text-left">
              <Typography className="text-small label" variant="subtitle2">Folder Name*</Typography>
              <TextField fullWidth className="report_form_ui_input" placeholder="" onChange={handleFolderName} value={folderName}
                error={error?.folderError}
                helperText={error?.folderError}
              />

              <Typography className="text-small label" variant="subtitle2" sx={{ mt: 2 }}>Folder Description</Typography>
              <TextField fullWidth className="report_form_ui_input" placeholder="" onChange={handleFoldeDescription} value={folderDescription} />
              <Box className="modal-footer text-right" >
                <Button onClick={() => handleAddFolderPopup('Cancel')} className={classes.outlineButton + " report_form_ui_btn cancel mr-2"} color="primary" variant="outlined" > Cancel </Button>
                <Button onClick={submitAddFolder} color="primary" autoFocus className={classes.containedButton + " report_form_ui_btn submit"} variant="contained"> Submit </Button>
              </Box>
            </Box>

          </Box>
        </Fade>
      </Modal>

      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={moveReportPopup}
        closeAfterTransition
      >
        <Fade in={moveReportPopup}>
          <Box className={classes.selectFolderModalPaper + " modal-box modal-md"} id="transition-modal-title" sx={{ p: '1rem 2rem !important', }}>
            <Box className="modal-header" sx={{ p: '0 0 1rem !important', m: '0rem !important' }}>
              <Typography variant="subtitle1" className={classes.modalTitle + " modal-header-title folder-modal-title pl-0"} >{`Move Report`}</Typography>
            </Box>
            <Box className="modal-content mb-0 pb-0 folders-list-modal" sx={{ p: '0rem !important', }}>
              <Box className={classes.selectFolderList + " br-4"} >
                <List component="nav">
                  {!foldersList?.length ? 'No Folders' : null}
                  {foldersList?.map((folder, i) => (
                    <ListItem key={i} button className={folder._id === moveReportObj.folderId ? 'visualize_list_text' : ''} onClick={() => handleMoveReport(folder)}>
                      <ListItemIcon>
                        <SvgIcon color="primary" component={FolderIcon} sx={{ marginTop: '-8px' }} />
                      </ListItemIcon>
                      <Typography> {folder.folderName} </Typography>
                    </ListItem>
                  ))}
                </List>
              </Box>
            </Box>

            <Box className="modal-content my-0 text-left bb-1" sx={{ p: '0 0 1rem !important', }}>
              <IconButton component="" to="" className="no-hover pl-0" onClick={() => { handleMoveReportPopup('Cancel'); handleAddFolderPopup('Add') }}>
                <SvgIcon color="primary" component={FolderIcon} sx={{ marginTop: '-8px' }} />
                <Typography sx={{ fontSize: '16px', color: '#4482FF', paddingLeft: "1rem" }}  > Create New Folder </Typography>
              </IconButton>
            </Box>

            <Box className="modal-footer text-right">
              <Button onClick={() => handleMoveReportPopup('Cancel')} className={classes.outlineButton + " report_form_ui_btn cancel mr-2"} color="primary"
                variant="outlined" > Cancel </Button>
              <Button onClick={submitMoveReport} disabled={moveReportObj?.folderId ? false : true} color="primary" autoFocus
                className={classes.containedButton + " report_form_ui_btn submit"} variant="contained"> Done </Button>
            </Box>
          </Box>
        </Fade>
      </Modal>

      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={changeOwnerPopup}
        closeAfterTransition
      >
        <Fade in={changeOwnerPopup}>
          <Box className={classes.modalPaper + " modal-box modal-md"} id="transition-modal-title">
            <Box className="modal-header p-1" >
              <Typography variant="subtitle1" className={classes.modalTitle + " modal-header-title"} >{`Change Report Owner (${changeOwnerReportObj?.reportName})`}</Typography>
            </Box>
            <Box className="modal-content text-left">
              <Autocomplete
                  value={changeOwnerReportObj?.currentOwner ?? null}
                  options={userList}
                  //renderValue={(selected) => selected.join(", ")}
                  label="Select Owner"
                  getOptionLabel={(option) => { return `${option.firstName} ${option.lastName} (${option.s_uuid})`}}
                  onChange={(e,obj) => setOwnerObj(obj)}
                  renderInput={(params) => (
                    <TextField {...params} label="Select Owner" variant="standard" />
                  )}
                />           
              <Box className="modal-footer text-right" >
                <Button onClick={() => handleChangeOwnerPopup('Cancel')} className={classes.outlineButton + " report_form_ui_btn cancel mr-2"} color="primary" variant="outlined" > Cancel </Button>
                <LoadingButton loading={changeOwnerLoading} onClick={onChangeOwner} color="primary" autoFocus className={classes.containedButton + " report_form_ui_btn submit"} variant="contained"> Change </LoadingButton>
              </Box>
            </Box>
          </Box>
        </Fade>
      </Modal>

      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className="modal-root"
        open={restrictOption}
        onClose={() => setRestrictOption(false)}
        closeAfterTransition
      >
        <Fade in={restrictOption}>
          <Box className="modal-paper modal-box modal-xs" id="transition-modal-title">
            <Box className="modal-content-simple text-center" sx={{ p: '1rem !important' }}>
              <ErrorOutlineSharpIcon color="primary" />
              <Typography variant="subtitle1" className="text-plain font-weight-normal">To use Custom Reports Feature, Switch to Desktop screen</Typography>
            </Box>
          </Box>
        </Fade>
      </Modal>


    </Page >
  )
}
